import { BET_KIND_HELP, BET_KIND_LABELS, type KnBetKind } from "@ziolo/shared";
import { Button } from "@ziolo/ui";

const KINDS: KnBetKind[] = ["win", "place", "show", "exacta", "quinella", "trifecta"];

export function KonieHelp({ onClose }: { onClose: () => void }) {
  return (
    <div
      className="kn-help-root"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="kn-help" role="dialog" aria-labelledby="kn-help-title">
        <div className="kn-help__head">
          <h2 id="kn-help-title">Jak obstawiać</h2>
          <Button size="sm" onClick={onClose}>
            Zamknij
          </Button>
        </div>
        <p className="kn-help__lead">
          Sześć koni, jeden tor. Wybierz rodzaj zakładu, kliknij konia (albo dwóch / trzech przy
          exoticach), rzuć żetony i oglądaj finisz. Kursy są dziesiętne: wypłata to stawka × kurs.
          Wynik losuje serwer — klient tylko animuje.
        </p>
        <ul className="kn-help__list">
          {KINDS.map((kind) => (
            <li key={kind}>
              <strong>{BET_KIND_LABELS[kind]}</strong>
              <span>{BET_KIND_HELP[kind]}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
